var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('transition',{attrs:{"name":_vm.transitionName,"mode":"out-in","type":"animation"}},[_c('router-view',{attrs:{"paymentLinkId":_vm.recordId},on:{"rowClick":function($event){return _vm.enterRow($event)}}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }